/* eslint-disable no-console */
const timeline = () => {
  const timelineEventGridContainer = document.getElementById('timeline-event-grid');
  if (timelineEventGridContainer === null) {
    return;
  }
  const defaultFilterName = 'all';
  let activeFilter = defaultFilterName;
  // Add tabindex to the timeline grid
  const timelineEventGridRow = timelineEventGridContainer.querySelector('.row');
  timelineEventGridRow.setAttribute('tabindex', '0');
  // Add results label for screenreaders
  const h2 = document.createElement('h2');
  h2.classList.add('sr-only');
  h2.id = 'results-focus';
  h2.setAttribute('role-status', 'status');
  h2.setAttribute('tabindex', '0');
  timelineEventGridContainer.insertBefore(h2, timelineEventGridRow);
  const resultsH2 = document.getElementById('results-focus');

  const setActiveNav = () => {
    const navItemList = document.querySelectorAll('.timeline-nav li');
    for (let i = 0; i < navItemList.length; i++) { /* eslint-disable-line no-plusplus */
      navItemList[i].classList.remove('active');
    }
    if (document.querySelector(`.timeline-nav [data-dateNav="${activeFilter}"]`) !== null) {
      document.querySelector(`.timeline-nav [data-dateNav="${activeFilter}"]`).classList.add('active');
    }
  };

  const filter = () => {
    const itemList = document.querySelectorAll('[data-dateRange]');
    let item;
    let resultCt = 0;
    for (let i = 0; i < itemList.length; i++) { /* eslint-disable-line no-plusplus */
      item = itemList[i];
      if (item.getAttribute('data-dateRange') === activeFilter || activeFilter === defaultFilterName) {
        item.removeAttribute('style');
        resultCt += 1;
      } else {
        item.setAttribute('style', 'display:none;');
      }
    }
    // Set results label text
    let eventLabel = 'events';
    if (resultCt === 1) {
      eventLabel = 'event';
    }
    let rangeLabel = `between ${activeFilter}`;
    if (activeFilter === 'all') {
      rangeLabel = '';
    }
    resultsH2.innerHTML = `${resultCt} ${eventLabel} ${rangeLabel}`;
    // Set focus to hidden results label
    resultsH2.focus();
  };

  [].map.call(document.querySelectorAll('.timeline-nav li'), btn => btn.addEventListener('click', () => {
    activeFilter = btn.getAttribute('data-dateNav');
    setActiveNav();
    filter();
  }));

  setActiveNav();
  filter();
};

export default timeline;
/* eslint-enable no-console */
